if (!customElements.get('collection-items-remaining')) {
  class CollectionItemsRemaining extends HTMLElement {
    constructor() {
      super();
      this.handleUpdateRef = this.handleUpdate.bind(this);
    }

    handleUpdate(event) {
      if (event.detail.id != this.getAttribute('data-id')) return;

      const parser = new DOMParser().parseFromString(event.detail.html, 'text/html');
      const items = parser.querySelector('collection-items-remaining');
      if (!items) return;

      this.innerHTML = items.innerHTML;

      const fetchedSection = parser.querySelector('.remaining-products');
      const currentSection = this.closest('.remaining-products');
      if (fetchedSection && currentSection) {
        currentSection.hidden = fetchedSection.hasAttribute('hidden');
      }
    }

    connectedCallback() {
      document.addEventListener('exo:update-collection-items', this.handleUpdateRef);
    }

    disconnectedCallback() {
      document.removeEventListener('exo:update-collection-items', this.handleUpdateRef);
    }
  }

  customElements.define('collection-items-remaining', CollectionItemsRemaining);
}
